// Exotics widgets share PricingProvider (architect E8). Thin pass-through.
import type { FC } from 'react';

import ExoticsCalculateBandWidget from './exotics-calculate-band-widget';
import type { ExoticsCalculateBandProps } from './types';

const ExoticsCalculateBandWrapperProvider: FC<ExoticsCalculateBandProps> = (props) => (
  <ExoticsCalculateBandWidget {...props} />
);

export default ExoticsCalculateBandWrapperProvider;
